<div class="w-full px-4">
    <div class="w-full flex flex-column gap-3">
        <div class="grid">
            <h1 class="text-left col-10 font-bold text-4xl">Scheduled Calls</h1> 
        </div>
        <div class="w-full flex flex-column gap-2 py-4 px-3 bg-white border-round-2xl shadow-2">
          <h2 class="text-left font-medium text-2xl" style="color: #303030;">Search</h2>
          <form [formGroup]="filterForm" (ngSubmit)="loadPeerCallsByRole(1)" class="w-full flex flex-wrap">
            <div class="w-full grid">
              <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
                <b class="font-regular text-base" style="color: #505050;">From Date</b>
                <p-calendar placeholder="From date" formControlName="fromDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
                  class="w-full" styleClass="fullWidth" />
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
                <b class="font-regular text-base" style="color: #505050;">To Date</b>
                <p-calendar placeholder="To Date" formControlName="toDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
                  class="w-full" styleClass="fullWidth" />
              </div> 
              <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
                <b class="font-regular text-base" style="color: #505050;">Peer Name</b>
                <p-autoComplete placeholder="Name" formControlName= "peerName" [suggestions]="peerNames"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && !filterForm.get('peerName')?.value}"
                  class="w-full" (completeMethod)="filterPeerNames($event)" styleClass="fullWidth" optionValue="name"
                  optionLabel="name">
                </p-autoComplete>
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
                <b class="font-regular text-base" style="color: #505050;">Student Name</b>
                <p-autoComplete placeholder="Name" formControlName= "studentName" [suggestions]="studentNames"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && !filterForm.get('studentName')?.value}"
                  class="w-full" (completeMethod)="filterStudentNames($event)" styleClass="fullWidth" optionValue="name"
                  optionLabel="name">
                </p-autoComplete>
              </div>            
              <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
                <div class="w-full" style="padding-top: 23px;">
                  <p-button type="submit" label="Search" class="w-full" styleClass="save_btn1" />
                </div>
              </div>
          </div>
        </form>
      </div>
      <form [formGroup]="meetingUrlForm" >
        <div class="w-full">
          <p-table  *ngIf="peerListByAdmin && peerListByAdmin.length > 0; else noRecordsFound" [value]="peerListByAdmin"  [showCurrentPageReport]="true"
            [paginator]="peerListByAdmin.length!=totalRecords" [rows]="rowSize" [totalRecords]="totalRecords" [first]="first" [lazy]="true"
            [lazyLoadOnInit]="false" [loading]="isLoading" [loadingIcon]="'pi pi-spinner'"
            (onLazyLoad)="onLazyLoad($event)" [rowsPerPageOptions]="[10, 20, 30]" [showPageLinks]="true"
            styleClass="p-datatable-gridlines tableCon" [tableStyle]="{ 'min-width': '50rem' }">
            <ng-template pTemplate="header">
              <tr>
                <th>Peer Name</th>
                <th>Student Name</th>
                
                <th>Date</th>
                <th>Time Slot</th>
                <th>Purpose</th>
                <th>Meeting Url</th>
                <th>Send via Email</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-i="rowIndex">
    
              <tr>
                <td>{{item.peerReviewerFirstName}} {{item.peerReviewerLastName}}</td>
                <td>{{item.studentFirstName}} {{item.studentLastName}}</td>
                
                <td>{{item.meetingDate | date: 'MMM dd/yyyy'}}</td>
                <td>{{item.timeZone}}: {{item.timeFrom}} - {{item.timeFrom}}</td>
                <td>{{item.purpose}}</td>
                  <td>
                    <textarea class="w-full" style="border: 1px solid #CCD7E7; border-radius: 4px; padding: 8px; box-sizing: border-box;"
                      rows="2"
                      cols="10"
                      pInputTextarea 
                      [formControl]="getFormControl(i)">
                    </textarea>
                  </td>
                  <td>
                    <p-button (click)="onSendMeetingUrl(i)" label="Send Email" icon="pi pi-envelope" styleClass="viewapplication" />
                  </td>
              </tr>
            </ng-template>
          </p-table>
          <ng-template #noRecordsFound>
            <div class="w-full flex flex-column align-items-center py-4 gap-5">
              <div class="w-full flex align-items-center justify-content-center">
                <img src="../../../assets/icons/nodatafound.svg" alt="" class="w-full max-w-16rem">
              </div>
              <b class="text-center font-normal text-2xl" style="color: #000086;">No Data Found !</b>
            </div>
          </ng-template>
        </div>
      </form>

    </div>
  </div>

